import React, { Fragment } from 'react';
import { Row, Col, List, ListItem, Card, Container, HeadingFour } from 'hui';
import PropTypes from 'prop-types';

const StateLinks = ({ category, states }) => {
  return (
    <Fragment>
      {states.map(state => {
        const url = `/find/${category.key}/${state.code.toLowerCase()}`;
        return (
          <ListItem href={url} key={state.code} bullet={true}>
            {category.name} near {state.name}
          </ListItem>
        );
      })}
    </Fragment>
  );
};

const CapitalCityLinks = ({ category, states }) => {
  return (
    <Fragment>
      {states.map(state => {
        const capital = state.capital;
        if (!capital) {
          return null;
        }
        const url = `/find/${category.key}/${state.code.toLowerCase()}/${capital.code}`;
        return (
          <ListItem href={url} key={capital.code} bullet={true}>
            {category.name} near {capital.name}
          </ListItem>
        );
      })}
    </Fragment>
  );
};

/**
 * Render the links to category page of each state and capital city
 *
 * @param {object<{key: string, name: string}>} category
 * @param {Array<{code: string, name: string, capital: object<{code: string, name: string}>}>} states
 *
 * @return {React.Component}
 * @constructor
 */
const CategoryList = ({ category, states }) => {
  if (!category || !category.key || !category.name || !states || states.length <= 0) {
    return null;
  }
  return (
    <Container>
      <Row>
        <Col xs={12}>
          <Card snow p={1} mb={1}>
            <HeadingFour mt={0}>Browse the local directory for {category.name}</HeadingFour>
            <List columnCount={2} columnWidth={12.5}>
              <StateLinks category={category} states={states} />
              <CapitalCityLinks category={category} states={states} />
            </List>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

const categoryType = PropTypes.shape({
  key: PropTypes.string,
  name: PropTypes.string
});

const statesType = PropTypes.arrayOf(
  PropTypes.shape({
    code: PropTypes.string,
    name: PropTypes.string,
    capital: PropTypes.shape({
      code: PropTypes.string,
      name: PropTypes.string
    })
  })
);

CategoryList.propTypes = {
  /**
   * Category object with key and name
   */
  category: categoryType,

  /**
   * States with capitl city as a property
   */
  states: statesType
};

StateLinks.propTypes = CategoryList.propTypes;

CapitalCityLinks.propTypes = CategoryList.propTypes;

export default CategoryList;
